module.exports = __webpack_public_path__ + "img/xiaozi_shuzi.b8491397.svg";